import React, { PropsWithChildren, HTMLAttributes } from 'react';

export type PillProps = HTMLAttributes<HTMLSpanElement> & {
  color?: string;
  width?: React.CSSProperties['width'];
  height?: React.CSSProperties['height'];
  style?: React.CSSProperties;
  className?: string;
};

export const Pill: React.FC<PropsWithChildren<PillProps>> = ({
  style,
  className,
  width = 32,
  height = 12,
  color,
  children = null,
  ...spanProps
}) => (
  <span
    {...spanProps}
    className={className}
    style={{
      content: ' ',
      width,
      height,
      borderRadius: `calc(${height} / 2)`,
      display: 'inline-block',
      backgroundColor: color,
      ...style,
    }}
  >
    {children}
  </span>
);
